import React from 'react';
import { Link } from 'react-router-dom';
import { Wordmark } from '../brand/Wordmark';
import { NewTabHint } from '../ui/NewTabHint';
import { Reveal } from '../motion/Reveal';
import { brandDescriptor } from '../../data/brandAssets';
import { allRoutes, emailAddress, externalLinks } from '../../data/site';
const connectLinks = [{
  label: 'Instagram',
  href: externalLinks.instagram
}, {
  label: 'Discord',
  href: externalLinks.discord
}, {
  label: 'KnightConnect',
  href: externalLinks.knightConnect
}, {
  label: 'Photo Album',
  href: externalLinks.photoAlbum
}, {
  label: 'Get Connected Form',
  href: externalLinks.getConnectedForm
}];
export function Footer() {
  const year = new Date().getFullYear();
  return <footer className="on-dark w-full bg-brand-navy text-white" data-id="element-295" data-mp="3j30cp2t1hk49">
      <div className="mx-auto w-full max-w-6xl px-5 py-14 sm:px-8" data-id="element-296" data-mp="3e2me0bdbvmiw">
        <Reveal data-id="element-297" data-mp="3e4yt8grpbis9">
          <div className="grid gap-10 sm:grid-cols-2 sm:gap-12 lg:grid-cols-[1.4fr_1fr_1fr]" data-id="element-298" data-mp="393t04hu4pti7">
            <div data-id="element-299" data-mp="3965igw3su5vs">
              {/* Supplied artwork on a light brand plate — never recolored. */}
              <Link to="/" aria-label={`UCF BCM — ${brandDescriptor} — home`} data-id="element-300" data-mp="2p3te28drwdax">
                <Wordmark onDark className="h-8" data-id="element-301" data-mp="2p5xrpi1h4qoe" />
              </Link>
              <p className="mt-4 font-meta text-[12px] font-medium uppercase tracking-[0.16em] text-brand-blue" data-id="element-302" data-mp="2bdpwvvtr39sc">
                {brandDescriptor}
              </p>
              <p className="mt-3 max-w-sm font-sans text-[15px] leading-relaxed text-white" data-id="element-303" data-mp="341dh39r3zyeg">
                A Christian community for college students at UCF and surrounding campuses.
              </p>
              <p className="mt-4 font-meta text-[13px] font-medium text-brand-yellow" data-id="element-304" data-mp="2u3fqwgpovrj7">
                Thursdays at 7:30 PM during the school year
              </p>
              <a href={externalLinks.email} className="mt-2 inline-block font-meta text-[13px] text-white underline underline-offset-4 hover:text-brand-yellow" data-id="element-305" data-mp="2z43pbng8zang">
                {emailAddress}
              </a>
            </div>

            <nav aria-label="Footer site links" data-id="element-306" data-mp="13k7wad7zl1ok">
              <h2 className="font-meta text-xs font-semibold uppercase tracking-[0.18em] text-brand-blue" data-id="element-307" data-mp="zje9jn6a5sx9">
                Explore
              </h2>
              <ul className="mt-4 space-y-3" data-id="element-308" data-mp="uquuelry2pqc">
                {allRoutes.map(route => <li key={route.to} data-id="element-309" data-mp="pstc432ceufx">
                    <Link to={route.to} className="inline-block py-0.5 font-sans text-[15px] text-white transition-colors hover:text-brand-yellow" data-id="element-310" data-mp="ku89xy3j60ou">
                      {route.label}
                    </Link>
                  </li>)}
              </ul>
            </nav>

            <nav aria-label="Footer connect links" data-id="element-311" data-mp="6vs3875o4a6p">
              <h2 className="font-meta text-xs font-semibold uppercase tracking-[0.18em] text-brand-blue" data-id="element-312" data-mp="267kwbspc4ve5">
                Connect
              </h2>
              <ul className="mt-4 space-y-3" data-id="element-313" data-mp="219syyj5x8h2k">
                {connectLinks.map(link => <li key={link.label} data-id="element-314" data-mp="28r7qx82d75sa">
                    <a href={link.href} target="_blank" rel="noopener noreferrer" className="inline-block py-0.5 font-sans text-[15px] text-white transition-colors hover:text-brand-yellow" data-id="element-315" data-mp="28q6b6qaelv48">
                      {link.label}
                      <NewTabHint data-id="element-316" data-mp="1pty5jldhbi8e" />
                    </a>
                  </li>)}
              </ul>
            </nav>
          </div>
        </Reveal>

        <p className="mt-12 font-meta text-[13px] text-white" data-id="element-317" data-mp="1zrc94keb0cja">
          © {year} UCF Baptist Collegiate Ministries
        </p>
      </div>
    </footer>;
}